import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from "antd";

const ContainerTab = () => {

const columns = [
{ title: "Container No.", dataIndex: "SNo", key: "SNo" },
{ title: "ISO Code", dataIndex: "action", key: "action" },
{ title: "Movement", dataIndex: "TrackingURL", key: "TrackingURL" },
{ title: "Tare Wt", dataIndex: "HomepageURL", key: "HomepageURL" },
{ title: "Net Wt", dataIndex: "NVOCC", key: "NVOCC" },
{ title: "Gross Wt", dataIndex: "NVOCC", key: "NVOCC" },

{ title: "Payload Wt", dataIndex: "NVOCC", key: "NVOCC" },

{ title: "Custom Seal No.", dataIndex: "NVOCC", key: "NVOCC" },
{ title: "Carrier Seal No.", dataIndex: "NVOCC", key: "NVOCC" },
{ title: "Shipper Seal No.", dataIndex: "NVOCC", key: "NVOCC" },
{ title: "CTO Seal No.", dataIndex: "NVOCC", key: "NVOCC" },
{ title: "Temperature", dataIndex: "NVOCC", key: "NVOCC" },






];

const dataSource = [
{
key: "", // Add a unique key for each row
SNo: "", // Changed to camelCase

},
]

return (
<>
    <div className="row border-bottom-2 card m-1">
        <div className="col-md-12 card-body">
        
            
            <div className="table-responsive custom-table">
                <Table className="table datanew dataTable no-footer" pagination={false} dataSource={dataSource}
                    columns={columns} />
            </div>
            <div className="row mt-2">
            <div className="col-md-4">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                           Container No.
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input type="text" className="form-control form-control-sm" name='search_by' />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                          Net Wt
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <input type="number" className="form-control form-control-sm" name='search_by'  placeholder='0.00'/>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                            Volume
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                        <input type="number" className="form-control form-control-sm" name='search_by'  placeholder='0.00'/>
                        </div>
                    </div>
                </div>

               
            </div>

            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button">
                    Edit
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Update
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Cancel
                </button>
             
            </div>
        </div>
    </div>

</>
);
};

export default ContainerTab